import { createSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickOrderValidity, getOneClickResult } from '../../selectors/one-click-orders.selector';

const oneClickResultAndValidity = createSelector(getOneClickResult, getOneClickOrderValidity, (result, validity) => ({
  result,
  validity,
}));

export class OneClickHasResultOrInvalidProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(oneClickResultAndValidity).pipe(
      map(({ result, validity }) => {
        if (validity === null) {
          return true;
        } else {
          return !!result || !validity;
        }
      }),
    );
  }
}
